/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from 'styled-components';

import { Autocomplete } from 'components/chroma';

const AutocompleteWrapper = styled.div`
  .c-autocomplete__item:last-of-type {
    .c-autocomplete__button {
      text-decoration: underline;
    }
  }
`;

export const CANNOT_FIND_ADDRESS = "Can't find your address?";

export const AutocompleteAddress = ({ ...props }) => {
  const { values } = props;
  return (
    <AutocompleteWrapper>
      <Autocomplete
        {...props}
        values={
          values
            ? [
                ...values,
                {
                  label: CANNOT_FIND_ADDRESS,
                  value: {},
                },
              ]
            : []
        }
      />
    </AutocompleteWrapper>
  );
};

export default AutocompleteAddress;
